"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateSelfClassificationButton = exports.AddSelfClassificationButton = exports.UPDATE_SELF_CLASSIFICATION_BUTTON_TEST_ID = exports.ADD_SELF_CLASSIFICATION_LINK_TEST_ID = void 0;
const Button_1 = require("@amzn/atoz-web/Button");
const Icons_1 = require("@amzn/atoz-web/Icons");
const Modal_1 = require("@amzn/atoz-web/Modal");
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const logger_1 = require("../../../../logger");
const contexts_1 = require("../../../../contexts");
exports.ADD_SELF_CLASSIFICATION_LINK_TEST_ID = 'add-self-classification-link';
exports.UPDATE_SELF_CLASSIFICATION_BUTTON_TEST_ID = 'update-self-classification-button';
const AddSelfClassificationButton = ({ renderModal, isATPlus }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { clientName } = (0, contexts_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    (0, react_1.useEffect)(() => {
        if (isATPlus) {
            logger_1.logger.emitCountMetric({
                metricName: logger_1.METRICS.ATPLUS_SELF_CLASSIFICATION_ADD_BUTTON_RENDER.COUNT,
                dimensions
            });
        }
        else {
            logger_1.logger.emitCountMetric({
                metricName: logger_1.METRICS.SELF_CLASSIFICATION_ADD_BUTTON_RENDER.COUNT,
                dimensions
            });
        }
    }, []);
    return (react_1.default.createElement(Modal_1.WithModal, { renderModal: renderModal, shouldCloseOnClickOutside: false }, ({ open }) => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.Button, { onClick: open, dataTestId: exports.ADD_SELF_CLASSIFICATION_LINK_TEST_ID, variant: Button_1.ButtonVariant.Tertiary, "aria-label": 'Add paycode' }, t('time_and_attendance_HourlyBreakdown_SelfClassification_AddHours'))))));
};
exports.AddSelfClassificationButton = AddSelfClassificationButton;
const UpdateSelfClassificationButton = ({ renderModal, paycode, isATPlus }) => {
    const { clientName } = (0, contexts_1.useTaaConfigsContext)();
    const dimensions = {
        ClientName: clientName,
        ClientType: logger_1.ClientType.WEB
    };
    (0, react_1.useEffect)(() => {
        if (isATPlus) {
            logger_1.logger.emitCountMetric({
                metricName: logger_1.METRICS.ATPLUS_SELF_CLASSIFICATION_EDIT_BUTTON_RENDER.COUNT,
                dimensions
            });
        }
        else {
            logger_1.logger.emitCountMetric({
                metricName: logger_1.METRICS.SELF_CLASSIFICATION_EDIT_BUTTON_RENDER.COUNT,
                dimensions
            });
        }
    }, []);
    return (react_1.default.createElement(Modal_1.WithModal, { renderModal: renderModal, shouldCloseOnClickOutside: false }, ({ open }) => (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.Button, { dataTestId: exports.UPDATE_SELF_CLASSIFICATION_BUTTON_TEST_ID, icon: react_1.default.createElement(Icons_1.IconPencil, { title: "Update Self Classification", color: "primary50" }), variant: Button_1.ButtonVariant.Tertiary, onClick: open, "aria-label": `Edit ${paycode}` })))));
};
exports.UpdateSelfClassificationButton = UpdateSelfClassificationButton;
